import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=400bee06&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=400bee06&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400bee06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('400bee06')) {
      api.createRecord('400bee06', component.options)
    } else {
      api.reload('400bee06', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=400bee06&scoped=true", function () {
      api.rerender('400bee06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/components/Add.vue"
export default component.exports